module.exports = __webpack_public_path__ + "static/media/Gotham-Bold.cb2611be.woff";